module.exports = __webpack_public_path__ + "static/media/goblin.6f333db5.png";